"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadedFonts = void 0;
var renderer_utils_1 = require("@moonpig/renderer-utils");
var equality_1 = __importDefault(require("@wry/equality"));
var react_1 = require("react");
var renderer_provider_1 = require("../renderer-provider");
var useLoadedFonts = function (fontUrls) {
    var resourceContext = (0, renderer_provider_1.useRendererContext)().resourceContext;
    var _a = __read((0, react_1.useState)({ type: 'LOADING' }), 2), state = _a[0], setState = _a[1];
    var lastFontUrls = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if ((0, equality_1.default)(fontUrls, lastFontUrls.current)) {
            return;
        }
        lastFontUrls.current = fontUrls;
        var load = function () { return __awaiter(void 0, void 0, void 0, function () {
            var fontEntries, fonts, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        setState({ type: 'LOADING' });
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Promise.all(fontUrls.map(function (fontUrl) { return __awaiter(void 0, void 0, void 0, function () {
                                var _a;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            _a = [fontUrl];
                                            return [4 /*yield*/, resourceContext.loadFont({ fontUrl: fontUrl, fontMetrics: null })];
                                        case 1: return [2 /*return*/, _a.concat([
                                                _b.sent()
                                            ])];
                                    }
                                });
                            }); }))];
                    case 2:
                        fontEntries = _a.sent();
                        fonts = fontEntries.reduce(function (acc, _a) {
                            var _b = __read(_a, 2), fontUrl = _b[0], fontData = _b[1];
                            acc[fontUrl] = fontData;
                            return acc;
                        }, {});
                        setState({
                            type: 'LOADED',
                            fonts: fonts,
                        });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        setState({ type: 'ERROR', message: (0, renderer_utils_1.toError)(error_1).message });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        load();
    }, [fontUrls]);
    return state;
};
exports.useLoadedFonts = useLoadedFonts;
